import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ImageViewerComponent } from 'src/app/shared/components/image-viewer/image-viewer.component';

@Component({
  selector: 'app-chunk-image-displayer',
  template: `
    <div class="image">
      <app-image-viewer [src]="imageUrl" objectFit="contain"></app-image-viewer>
    </div>
  `,
  styles: [
    `
      .image {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ImageViewerComponent],
})
export class ChunkImageDisplayerComponent {
  @Input() imageUrl;
}
